import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

export default function Login({ onLogin, darkMode, onToggleDark }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdfStatus, setPdfStatus] = useState(null);

  useEffect(() => {
    axios.get(`${API}/info`)
      .then(r => setPdfStatus(r.data.pdf_scrape_status))
      .catch(() => {});
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError("");
    try {
      const r = await axios.post(`${API}/auth/login`, { password });
      if (r.data.role) {
        onLogin(r.data.role, password);
      } else {
        setError("Password errata");
      }
    } catch {
      setError("Errore di connessione al server");
    }
    setLoading(false);
  };

  return (
    <div className="login-overlay">
      <button className="login-theme-toggle" onClick={onToggleDark} aria-label={darkMode ? "Modalità chiara" : "Modalità scura"} title={darkMode ? "Modalità chiara" : "Modalità scura"}>
        {darkMode
          ? <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
          : <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
        }
      </button>
      <div className="login-box">
        <div className="login-logo">
          <img
            src="https://www.finp.it/images/logofinp.png"
            alt="Logo FINP"
            className="login-finp-logo"
          />
          <img src="/logoDSP.png" alt="DigiSwimP" className="login-dsp-logo" />
          <p>Risultati nuoto paralimpico FINP</p>
        </div>
        <form onSubmit={handleLogin}>
          <input
            type="password"
            placeholder="Password di accesso"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoFocus
          />
          {error && <div className="login-error">{error}</div>}
          <button type="submit" disabled={loading || !password}>
            {loading ? "Accesso in corso..." : "Accedi"}
          </button>
          {pdfStatus === "error" && (
            <div className="login-pdf-status login-pdf-status--error">Verifica Records in corso...</div>
          )}
          {pdfStatus === "ok" && (
            <div className="login-pdf-status login-pdf-status--ok">Records aggiornati</div>
          )}
        </form>
      </div>
    </div>
  );
}
